/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Marker_StartInputs */

const vi_tracking_marker_start = /** @type {(inputs: Tracking_Marker_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu`)
};

/**

* @param {Tracking_Marker_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_marker_start = /** @type {((inputs?: Tracking_Marker_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Marker_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_marker_start(inputs)
});